var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuperInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9137 27.2283C32.1848 26.7764 32.6731 26.5 33.2 26.5H54.8C55.3269 26.5 55.8151 26.7764 56.0862 27.2283L63.2862 39.2283C63.6253 39.7934 63.5558 40.5136 63.1149 41.0034L45.1149 61.0034C44.8305 61.3195 44.4252 61.5 44 61.5C43.5748 61.5 43.1695 61.3195 42.885 61.0034L24.885 41.0034C24.4442 40.5136 24.3747 39.7934 24.7137 39.2283L31.9137 27.2283ZM34.0493 29.5L28.6493 38.5H33.8839L36.5839 29.5H34.0493ZM39.716 29.5L37.016 38.5H50.9839L48.2839 29.5H39.716ZM51.416 29.5L54.116 38.5H59.3507L53.9507 29.5H51.416ZM58.6319 41.5H53.9699L49.3078 51.8602L58.6319 41.5ZM44 56.3447L50.6801 41.5H37.3199L44 56.3447ZM34.0301 41.5L38.6922 51.8602L29.368 41.5H34.0301Z",
    fill: "#D6D8DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 86.5,
    height: 86.5,
    rx: 43.25,
    stroke: "#D6D8DD",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperInactive);
export default __webpack_public_path__ + "static/media/superInactive.53ab7cb3eef45fdc97db9206920062f0.svg";
export { ForwardRef as ReactComponent };